import { generateResolver, Modal, Notification, STATUS_TYPES, yup } from 'dyl-components';
import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Icon, Popup } from 'semantic-ui-react';
import campaign from 'actions/campaigns';

export default function RefreshTextCampaignModal({ open, onClose, campaign_id, refresh }) {
    const { isRefreshingTextCampaign } = useSelector((state) => state.campaigns)
    const { formState: { isValid, isDirty }, control, handleSubmit, reset } = useForm({
        mode: "onChange",
        defaultValues: {
            text_results: [],
            contact_status: [],
            reset_sent_text: true
        },
        resolver: generateResolver({
            text_results: yup
                .array()
                .min(1, "Please select at least one text result")
                .required("Text results are required"),

            contact_status: yup
                .array()
                .min(1, "Please select at least one contact status")
                .required("Contact status is required"),
            reset_sent_text: yup.boolean()
        }),
    })
    const dispatch = useDispatch()
    const submitHandler = async (data) => {
        try {
            await dispatch(campaign.refreshText({
                text_results: data?.text_results,
                contact_status: data?.contact_status,
                reset_sent_text: data?.reset_sent_text
            }, null, campaign_id))
            Notification.alert("Text campaign refreshed successfully", STATUS_TYPES.SUCCESS);
            reset()
            onClose();
            if (refresh) {
                refresh();
            }
        } catch (error) {
            console.error("Error refreshing text campaign:", error);
            Notification.alert("Failed to refresh text campaign", STATUS_TYPES.ERROR);
        }
    }
    return (
        <Modal open={open} onClose={onClose} size="tiny">
            <Modal.Header>
                Refresh Text
            </Modal.Header>
            <Modal.Content>
                <Form noValidate loading={isRefreshingTextCampaign}>
                    <Form.Group widths={'equal'}>
                        <Controller
                            name='text_results'
                            control={control}
                            render={({ field: { name, value, onChange } }) => (
                                <Form.Select
                                    name={name}
                                    value={value}
                                    required
                                    onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                    label='Include Text Results'
                                    placeholder='Select Results'
                                    multiple
                                    options={[
                                        { key: 'sent', value: 'sent', text: 'Sent' },
                                        { key: 'pending', value: 'pending', text: 'Pending' },
                                        { key: 'failed', value: 'failed', text: 'Failed' }
                                    ]}
                                    renderLabel={(label) => ({
                                        color: 'ToggableDropdown__label',
                                        content: label.text
                                    })}
                                />
                            )}
                        />
                        <Controller
                            name='contact_status'
                            control={control}
                            render={({ field: { name, value, onChange } }) => (
                                <Form.Select
                                    name={name}
                                    value={value}
                                    onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                    label='Contact Status'
                                    placeholder='Select'
                                    multiple
                                    required
                                    options={[
                                        { key: 'active', value: 'active', text: 'Active' },
                                    ]}
                                    renderLabel={(label) => ({
                                        color: 'ToggableDropdown__label',
                                        content: label.text
                                    })}
                                />
                            )}
                        />
                    </Form.Group>
                    <Controller
                        control={control}
                        name='reset_sent_text'
                        render={({ field: { name, value, onChange } }) => (
                            <Form.Field style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
                                <Form.Checkbox
                                    id="reset_sent_text"
                                    name={name}
                                    checked={value}
                                    onChange={(e, { checked }) => onChange({ target: { name, value: checked } })}
                                    disabled
                                />
                                <label htmlFor="reset_sent_text" style={{ cursor: 'pointer', margin: 0 }}>
                                    Reset Sent Text
                                    <Popup
                                        trigger={<Icon className='fas fa-info-circle' color='primary' style={{ marginLeft: '5px' }} />}
                                        content={<div>Opt-ed out Contacts will not reset</div>}
                                        inverted
                                        position='bottom center'
                                    />

                                </label>
                            </Form.Field>
                        )}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions
                hasSaveButton
                onSave={handleSubmit(submitHandler)}
                saveDisabled={!isValid || !isDirty || isRefreshingTextCampaign}
                saveOptions={{ loading: isRefreshingTextCampaign }}
            />
        </Modal>
    )
}
